import type { LabTypeahead, Typeahead as TypeaheadType } from "@shared/types/graphqlGenerated";

import type { TypeaheadResultSelectedV2 } from "../CatalogSearch/SearchInput/SearchInput";
import type { GroupName } from "../Typeahead/shared/TypeaheadGroupName";
import type { TypeaheadViewAll } from "../Typeahead/shared/TypeaheadViewAll";

import { TypeaheadGroup } from "./TypeaheadGroup/TypeaheadGroup";
import { TypeaheadResultsContainer } from "./TypeaheadResultsContainer/TypeaheadResultsContainer";

type Typeahead = Pick<TypeaheadType, "id" | "entityType" | "name">;

export type TypeaheadGroupType = {
  data: Typeahead[];
  entityType: GroupName;
};

interface Props {
  query: string;
  results: TypeaheadGroupType[];
  viewAllGroups?: TypeaheadViewAll[];
  highlightRowId: string;
  onResultClick: (result: TypeaheadResultSelectedV2 | LabTypeahead) => void;
  groupNames: GroupName[];
}

const Typeahead = ({
  query,
  results,
  viewAllGroups,
  highlightRowId,
  onResultClick,
  groupNames,
}: Props) => {
  const renderContent = () => {
    return results?.map((groupType, index) => {
      const previousElementsCount = results.slice(0, index).reduce((total, currentGroup) => {
        return total + (currentGroup?.data?.length || 0);
      }, 0);
      if (groupType?.data?.length > 0) {
        return (
          <TypeaheadGroup
            key={groupType?.entityType}
            highlightRowId={highlightRowId}
            query={query}
            groupName={groupNames[index]}
            data={groupType.data}
            viewAllGroup={viewAllGroups?.[index]}
            onResultClick={onResultClick}
            itemsBeforeGroup={previousElementsCount}
          />
        );
      }

      return null;
    });
  };

  return (
    <TypeaheadResultsContainer data-testid="typeahead-results">
      {renderContent()}
    </TypeaheadResultsContainer>
  );
};

export { Typeahead };
